import { render } from "./PaperDetails.vue?vue&type=template&id=9b9f7bb4"
import script from "./PaperDetails.vue?vue&type=script&lang=js"
export * from "./PaperDetails.vue?vue&type=script&lang=js"
script.render = render

export default script